module.exports = __webpack_public_path__ + "static/media/02.be5faeb7.png";